import { useCallback, useRef } from 'react';
import isBrowser from 'is-browser';

/**
 * Hook that provides a function to scroll to the top of a container element.
 * @param offset - Optional offset from the top (default: 0)
 * @returns A ref to attach to the container and a scroll function
 */
export const useScrollToTop = (offset: number = 0) => {
  const containerRef = useRef<HTMLElement | null>(null);

  const scrollToTop = useCallback(() => {
    if (!isBrowser || !containerRef.current) return;

    requestAnimationFrame(() => {
      if (window && containerRef.current) {
        const containerTop =
          containerRef.current.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: containerTop - offset });
      } else if (window) {
        window.scrollTo({ top: 0 });
      }
    });
  }, [offset]);

  return { containerRef, scrollToTop };
};
